var React = require('react');

function Vector (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M14.374 20a5.572 5.572 0 0 1-1.912-.342 20.385 20.385 0 0 1-7.4-4.718 20.384 20.384 0 0 1-4.718-7.4 5.532 5.532 0 0 1-.285-2.721A5.673 5.673 0 0 1 2.975.666 5.569 5.569 0 0 1 5.641 0a.625.625 0 0 1 .611.494l.981 4.578a.625.625 0 0 1-.169.573L5.388 7.321a16.451 16.451 0 0 0 7.291 7.291l1.676-1.676a.625.625 0 0 1 .573-.169l4.578.981a.625.625 0 0 1 .494.611 5.569 5.569 0 0 1-.666 2.667 5.673 5.673 0 0 1-4.153 2.916 5.559 5.559 0 0 1-.807.059zM5.142 1.277a4.379 4.379 0 0 0-3.626 5.834 18.956 18.956 0 0 0 11.373 11.373 4.379 4.379 0 0 0 5.834-3.626L15 14.06l-1.751 1.751a.625.625 0 0 1-.708.124A17.7 17.7 0 0 1 4.066 7.46a.625.625 0 0 1 .124-.708L5.94 5z"}));
}

Vector.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Vector;

Vector.default = Vector;
